// Module 2: KYC QA Assessment.
// Receives the extracted facts plus the original text excerpt and produces
// the 11-area regulator-grade quality assessment.

const TEXT_EXCERPT = 30_000;

export function buildKycQaMessage({ facts, fileText, fileName }) {
  return `Customer file under review: ${fileName || 'untitled'}

--- EXTRACTED FACTS (JSON) ---
${JSON.stringify(facts, null, 2)}

--- ORIGINAL FILE EXCERPT (first ${TEXT_EXCERPT.toLocaleString()} chars) ---
${(fileText || '').slice(0, TEXT_EXCERPT)}

--- END SOURCE MATERIAL ---

Now produce the 11-area QA assessment in the exact format specified in your instructions. Be strict. PASS only when there is unambiguous evidence on file.`;
}
